import { create } from 'zustand';

export const LFA_COST_DISCLAIMER =
  "The costs, including fees and commissions, and any financial information incorporating those costs are estimated and for informational purposes only. Your statement from the FCM is the definitive governing document with respect to cost's applicable to your account.";

type LfaAccountLike = {
  stage?: string | null;
  projectXAccountId?: number | null;
};

export const isLfaAccount = (account?: LfaAccountLike | null): boolean =>
  account?.stage === 'live-funded' && (account?.projectXAccountId ?? 0) > 0;

type LfaFooterDisclaimerState = {
  show: boolean;
  setShow: (show: boolean) => void;
};

export const useLfaFooterDisclaimer = create<LfaFooterDisclaimerState>((set) => ({
  show: false,
  setShow: (show) => set({ show }),
}));
